import isEmpty from 'lodash/isEmpty';
import lowerCase from 'lodash/lowerCase';
import { CATEGORIES_ID } from '@yme/common/constants';
import { getFacetProperty } from '@yme/components/SearchPage/hooks/helpers';
import { FacetFields } from '@yme/utils/bloomreach';
import { BLOOMREACH_ANALYTIC_KEYS_LIST } from '@yme/utils/bloomreach/constants';
import { getFacetsLabel } from '../common/helpers';
// Prepared Pills data
export function getPillsOptions(selectedFacets, dictionary, handleUpdateFacets, fallBackFacetsData) {
    const splittedSelectedFacets = selectedFacets.split('|');
    return splittedSelectedFacets.map((item) => {
        const [key, values] = item.split(':');
        const valuesArray = values.split(',').map((item) => {
            const itemKey = JSON.parse(item).trim();
            if (key === CATEGORIES_ID) {
                const categoryIdValues = (fallBackFacetsData &&
                    fallBackFacetsData.find((i) => i.id === key)?.values) ||
                    [];
                const currentFacet = categoryIdValues?.length &&
                    categoryIdValues.find((i) => i.value === itemKey);
                return (currentFacet && currentFacet?.name) || itemKey;
            }
            return itemKey;
        });
        const finallyValue = valuesArray.length <= 2
            ? valuesArray.slice(0, 2).join(', ')
            : `${valuesArray.slice(0, 2).join(', ')}... +${valuesArray.slice(2).length}`;
        const result = {
            groupId: key,
            label: getFacetsLabel({
                fullBackValue: key,
                key,
                dictionary,
            }),
            value: finallyValue,
            fullToolTipLabel: valuesArray.length > 2 ? valuesArray.join(', ') : undefined,
            handleDelete: () => handleUpdateFacets(key)([]),
        };
        return result;
    });
}
export function buildThresholdList(numSteps) {
    const thresholds = [];
    for (let i = 1.0; i <= numSteps; i++) {
        const ratio = i / numSteps;
        thresholds.push(ratio);
    }
    return thresholds;
}
export function getCurrentFacets(facets, facetsConfig) {
    return facets
        .filter((facet) => facetsConfig.includes(facet.name) && facet.value.length > 0)
        .map((facet) => {
        return {
            name: facet.name,
            id: facet.name,
            total: 0,
            values: facet.value.map((facetValue) => ({
                count: facetValue.count,
                value: facetValue.name,
                checked: false,
                idByValue: '',
                valueEn: '',
            })),
        };
    });
}
export const getFacetProperties = (categoryId, facets, primaryType, isShowOnlyDiscounted, search, productId) => {
    const categoryTypeQuery = `${FacetFields.CATEGORY}: "${categoryId}"`;
    const primaryTypeFacet = `${FacetFields.PRIMARY_TYPE}: "${lowerCase(primaryType)}"`;
    const facetProperties = Object.entries(facets);
    const facetQueries = facetProperties
        .map(([facetName, facetValue]) => {
        if (isEmpty(facetValue)) {
            return '';
        }
        return `${facetName}: ${getFacetProperty(facetValue)}`;
    })
        .filter(Boolean)
        .join(',');
    const onlyDiscountedFacet = isShowOnlyDiscounted ? `${FacetFields.IS_DISCOUNTED}: "1"` : null;
    const productFacet = productId ? `${FacetFields.COMPATIBLE_PRODUCTS}: "${productId}"` : null;
    if (search && facetQueries) {
        return [primaryTypeFacet, categoryTypeQuery, facetQueries, onlyDiscountedFacet, productFacet]
            .filter(Boolean)
            .join(',');
    }
    if (search) {
        return [primaryTypeFacet, categoryTypeQuery, onlyDiscountedFacet, productFacet]
            .filter(Boolean)
            .join(',');
    }
    return [primaryTypeFacet, facetQueries, onlyDiscountedFacet, productFacet]
        .filter(Boolean)
        .join(',');
};
export const getHasDiscountedProducts = (facets) => {
    return (facets
        .find((facet) => facet.name === FacetFields.IS_DISCOUNTED)
        ?.value.some((item) => Number(item.name) === 1) ?? false);
};
export const getDidYouMeanSearchParams = (option, searchParams) => {
    const params = new URLSearchParams(searchParams);
    params.set(BLOOMREACH_ANALYTIC_KEYS_LIST.search, option);
    return params.toString();
};
